var map = {
	"./certificate_automatic_frame.png": 234,
	"./certificate_ects_frame.png": 235,
	"./certificate_frame.png": 236,
	"./certificate_verified_frame.png": 237,
	"./frame_blue_de.png": 238,
	"./frame_blue_en.png": 239,
	"./frame_gold_de.png": 240,
	"./frame_gold_en.png": 241,
	"./frame_green_de.png": 242,
	"./frame_green_en.png": 243,
	"./generic_audit_sample.jpg": 244,
	"./generic_bundle_sample.jpg": 245,
	"./generic_coa_ects_sample.jpg": 246,
	"./generic_coa_sample.jpg": 247,
	"./generic_sop_sample.jpg": 248,
	"./milestone_completed.png": 249,
	"./milestone_completed.svg": 250,
	"./milestone_completed_small.svg": 251,
	"./milestone_uncompleted.png": 252,
	"./milestone_uncompleted.svg": 253,
	"./milestone_uncompleted_old.png": 254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 233;